<div class="predictive-container">
  <div class="chart-section">
    <div class="chart-header">
      <h3>Vibration Acceleration</h3>

      <!-- <div class="stats-summary" *ngIf="charts.vibrationAcceleration.thresholds.green">
        <div class="stat-item">
          <span class="label">Green Limit:</span>
          <span class="value">{{ charts.vibrationAcceleration.thresholds.green }}</span>
        </div>
        <div class="stat-item">
          <span class="label">Yellow Limit:</span>
          <span class="value">{{ charts.vibrationAcceleration.thresholds.yellow }}</span>
        </div>
        <div class="stat-item highlight">
          <span class="label">Red Limit:</span>
          <span class="value">{{ charts.vibrationAcceleration.thresholds.red }}</span>
        </div>
      </div>
    </div> -->

    <div class="loading-container" *ngIf="charts.vibrationAcceleration.loading">
      <div class="spinner"></div>
      <p>Loading chart data...</p>
    </div>

    <div class="no-data" *ngIf="!charts.vibrationAcceleration.loading && (!charts.vibrationAcceleration.dataSeries || charts.vibrationAcceleration.dataSeries.length === 0)">
      <p>No data available for Vibration Acceleration</p>
    </div>

    <app-trends-chart
      *ngIf="!charts.vibrationAcceleration.loading && charts.vibrationAcceleration.dataSeries.length > 0"
      [dataSeries]="charts.vibrationAcceleration.dataSeries"
      [thresholds]="charts.vibrationAcceleration.thresholds"
      [titleText]="''"
      titleY="Acceleration (mm/s²)"
      yAxisFormat="#0.#####"
    ></app-trends-chart>
  </div>


  <div class="chart-section">
    <div class="chart-header">
      <h3>Vibration Velocity</h3>
    </div>

    <div class="loading-container" *ngIf="charts.vibrationVelocity.loading">
      <div class="spinner"></div>
      <p>Loading chart data...</p>
    </div>

    <div class="no-data" *ngIf="!charts.vibrationVelocity.loading && (!charts.vibrationVelocity.dataSeries || charts.vibrationVelocity.dataSeries.length === 0)">
      <p>No data available for Vibration Velocity</p>
    </div>

    <app-trends-chart
      *ngIf="!charts.vibrationVelocity.loading && charts.vibrationVelocity.dataSeries.length > 0"
      [dataSeries]="charts.vibrationVelocity.dataSeries"
      [thresholds]="charts.vibrationVelocity.thresholds"
      [titleText]="''"
      titleY="Velocity (mm/s)"
    ></app-trends-chart>
  </div>


  <!-- <div class="chart-section">
    <div class="chart-header">
      <h3>Delta Ultrasound</h3>
    </div>

    <div class="loading-container" *ngIf="charts.deltaUltrasound.loading">
      <div class="spinner"></div>
      <p>Loading chart data...</p>
    </div>

    <div class="no-data" *ngIf="!charts.deltaUltrasound.loading && (!charts.deltaUltrasound.dataSeries || charts.deltaUltrasound.dataSeries.length === 0)">
      <p>No data available for Delta Ultrasound</p>
    </div>

    <app-trends-chart
      *ngIf="!charts.deltaUltrasound.loading && charts.deltaUltrasound.dataSeries.length > 0"
      [dataSeries]="charts.deltaUltrasound.dataSeries"
      [thresholds]="charts.deltaUltrasound.thresholds"
      [titleText]="''"
      titleY="Delta Ultrasound (db)"
    ></app-trends-chart>
  </div> -->


  <div class="chart-section">
    <div class="chart-header">
      <h3>Temperature</h3>
    </div>

    <div class="loading-container" *ngIf="charts.temperature.loading">
      <div class="spinner"></div>
      <p>Loading chart data...</p>
    </div>

    <div class="no-data" *ngIf="!charts.temperature.loading && (!charts.temperature.dataSeries || charts.temperature.dataSeries.length === 0)">
      <p>No data available for Temperature</p>
    </div>

    <app-trends-chart
      *ngIf="!charts.temperature.loading && charts.temperature.dataSeries.length > 0"
      [dataSeries]="charts.temperature.dataSeries"
      [thresholds]="charts.temperature.thresholds"
      [titleText]="''"
      titleY="Temperature (°C)"
    ></app-trends-chart>
  </div>

</div>
